// extracted by mini-css-extract-plugin
export default {"skills":"Skills_skills__au67r","skill-item":"Skills_skill-item__1Pb11","title_value":"Skills_title_value__3+ST9","value":"Skills_value__5Ywm7","progress":"Skills_progress__rGkA1"};